import React from 'react';
import { prop } from 'ramda';
import { NavLink } from 'react-router-dom';
import EditApplicationButton from 'Components/EditApplicationButton';

import { STATUS } from 'constants/index';

import Button, { buttonType, buttonColor } from 'Components/Button';

export default class ChangeStatus extends React.Component {
  getActionFromList = key => {
    const { availableActions } = this.props;
    return availableActions.find(action => action.key === key);
  };

  render() {
    const { applicationId, user } = this.props;

    const link = `/${user.getManufacturerCode()}/oil/formula/${applicationId}/edit`;

    const actions = [
      {
        key: 'edit',
        isShown: true,
        Component: () => (
          <NavLink to={link}>
            <EditApplicationButton className='_height_40 _width_pc_100 _max_width_180 _margin_right_20' />
          </NavLink>
        ),
      },
      {
        key: 'approve',
        isShown: this.getActionFromList(STATUS.APPROVED),
        Component: () => (
          <Button
            label='Approve'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={this.getActionFromList(STATUS.APPROVED).action}
            type={buttonType.primary}
            color={buttonColor.green}
          />
        ),
      },
      {
        key: 'deactivate',
        isShown: this.getActionFromList(STATUS.DEACTIVATED),
        Component: () => (
          <Button
            label='Deactivate'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={this.getActionFromList(STATUS.DEACTIVATED).action}
            color={buttonColor.red}
          />
        ),
      },
      {
        key: 'incomplete',
        isShown: this.getActionFromList(STATUS.INCOMPLETE),
        Component: () => (
          <Button
            label='Incomplete'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={this.getActionFromList(STATUS.INCOMPLETE).action}
            type={buttonType.primary}
            color={buttonColor.lightBlue}
          />
        ),
      },
      {
        key: 'submit',
        isShown: this.getActionFromList(STATUS.PENDING),
        Component: () => (
          <Button
            label='Submit'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={this.getActionFromList(STATUS.PENDING).action}
            type={buttonType.primary}
            color={buttonColor.orange}
          />
        ),
      },
    ];

    if (actions.filter(prop('isShown')).length === 0) {
      return null;
    }

    return (
      <section className='scene_section detailsScene__change-status-section'>
        <header>Actions</header>
        <div className='detailsScene__change-status-buttons-wrapper'>
          {actions.map(({ key, isShown, Component }) => isShown && <Component key={key} />)}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/Details/ChangeStatus.jsx